export default "__VITE_ASSET__d5cd14ae__"